// Browser helper that compiles .luis source and injects the result as CSS.
// It is used by playground tools and direct runtime integrations.
import { compileLuis, type LuisCompileResult } from '@lentystyle/compiler';
import { writeCssToStyleTag } from "./runtime/style-sheet";
import { applyRuntimeStyleNonce } from './runtime/style-nonce'
import { assertCompileResultSafe } from './runtime/loader/process/compile-entry-security'

// Compile source and write CSS to a stable style tag in the current document.
export function applyLuisToDocument(source: string, styleId = "luis-runtime-style"): LuisCompileResult {
  // Exit early when called outside of a browser-like environment.
  if (typeof document === "undefined") {
    throw new Error("applyLuisToDocument can only run in a browser environment.");
  }

  const result = compileLuis(source);
  assertCompileResultSafe(result)

  let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;
  // Create a style tag on first use for this style id.
  if (!styleTag) {
    styleTag = document.createElement("style");
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }
  applyRuntimeStyleNonce(styleTag)

  writeCssToStyleTag(styleTag, result.css);
  return result;
}
